import React, { useState, useRef, useEffect } from 'react'
import { TextInput, View, TouchableOpacity, Text } from 'react-native'
import { maxDecimals } from '../../utils/formatNumber.js'
import styles from './styles.js'

const { inputStyle, containerStyle, buttonStyle, buttonLeft, buttonRight, buttonText } = styles
const NumberInput = ({ value, onChange, minValue = 0, step = 1, tofixed = 8, parsed = true, onFocus, onBlur, maxDecimalsParam = 8 }) => {
  const [quantity, setQuantity] = useState(value)
  const input = useRef()
  const increment = () => {
    const number = (Number(quantity) + step).toFixed(tofixed)
    const parsedNum = parseFloat(number)
    setQuantity(parsed ? parsedNum : number)
    onChange(parsed ? parsedNum : number)
    if(onBlur){ onBlur(); }
  }
  const decrement = () => {
    if (quantity > minValue) {
      const number = (Number(quantity) - step).toFixed(tofixed)
      const parsedNum = parseFloat(number)
      setQuantity(parsed ? parsedNum : number)
      onChange(parsed ? parsedNum : number)
      if(onBlur){ onBlur(); }
    }
  }
  const change = (e) => {
    // const validatedInputString = e.replace(',', '.').replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2")
    
    let validatedInputString = e.replace(',', '.').replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2");
    validatedInputString = maxDecimals(validatedInputString, maxDecimalsParam);
    setQuantity(validatedInputString)
    onChange(validatedInputString)
  }

  useEffect(() => {
    if(value !== quantity) {
      setQuantity(value);
    }
  }, [value]);
  return (
    <View style={containerStyle}>
      <TouchableOpacity onPress={() => decrement()} style={[buttonStyle, buttonLeft]}>
        <Text style={buttonText}>-</Text>
      </TouchableOpacity>
      <TextInput
        ref={input}
        value={`${quantity}`}
        keyboardType="decimal-pad"
        onChangeText={text => change(text)}
        style={inputStyle}
      />
      <TouchableOpacity onPress={() => increment()} style={[buttonStyle, buttonRight]}>
        <Text style={buttonText}>+</Text>
      </TouchableOpacity>
    </View>
  )
}
export default NumberInput